module.exports = __webpack_public_path__ + "hotpFactor_ico@2x.ebba64953e3e13f13bfed619a87317af.png";